export const DEFAULT_BASE_URL = "https://hephaistos.impulselab.ai";
